import { useCallback, useSyncExternalStore } from "react";
import type { MessageData } from "../message-data-store";
import type { MessageEntrySource } from "../react-message-view";

/**
 * Subscribe to a single message entry from any MessageEntrySource.
 * Works with both ReactMessageView (push-based) and MessageDataStore (diff-based).
 * Only re-renders when that specific message's data changes.
 */
export function useMessageData(
  source: MessageEntrySource,
  messageId: string,
): MessageData | undefined {
  const subscribe = useCallback(
    (cb: () => void) => source.subscribe(messageId, cb),
    [source, messageId],
  );
  const getSnapshot = useCallback(
    () => source.get(messageId),
    [source, messageId],
  );
  return useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
}
